import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Controls = styled.div`
  margin: ${({ theme }) => theme.spacing(10, 'auto', 0)};
`;

export const Promo = styled.div`
  background-color: ${({ theme }) => theme.colors.neutral.bone};
  color: ${({ theme }) => theme.colors.border.fur};
  text-transform: uppercase;
  text-align: center;
  letter-spacing: 0.01em;
  border-radius: 71px;
  padding: ${({ theme }) => `${theme.spacing(2)} ${theme.spacing(4)}`};
  ${({ theme }) => theme.typography.subheading2}
  margin-top: ${({ theme }) => theme.spacing(10)};
  margin-bottom: ${({ theme }) => theme.spacing(8)};
`;
